import { Box, styled } from '@mui/material'

export const StyledFundStatsWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5, 0),
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2),
    backgroundColor: 'transparent',
  },
}))
